var sliders = {
  init() {
    // var prevArrow = '<button type="button" class="slick-prev"><i class="far fa-angle-left"></i></button>',
    //   nextArrow = '<button type="button" class="slick-next"><i class="far fa-angle-right"></i></button>';

    const $newsSlider = $('.js-news-cards');
    const newsSliderSettings = {
        dots: true,
        infinite: false,
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        mobileFirst: true,
        centerMode: false,
        rows: 0,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                dots: true,
                infinite: false,
                speed: 1500,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                centerMode: false,
                // centerPadding: '20px',
              },
            },
            {
              breakpoint: 1200,
              settings: 'unslick',
            },
        ],
    };

    $newsSlider.slick(newsSliderSettings);

    $(window).on('resize orientationChange', function () {
      if ($(this).width() < 1200 && $newsSlider.hasClass('slick-initialized') === false) {
        $newsSlider.slick(newsSliderSettings);
      }
    });



    $('.image-slider').slick({
      dots: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    });

    $('.case-study-slider').slick({
      dots: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      rows: 0,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
  });

    const $gallerySlider = $('.js-image-gallery');
    const gallerySliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      infinite: true,
      mobileFirst: true,
      rows: 0,
      responsive: [
        {
          breakpoint: 1025,
          settings: 'unslick',
        },
      ],
    };

    $gallerySlider.slick(gallerySliderSettings);

    $(window).on('resize orientationChange', function () {
      if ($(this).width() < 1025 && $gallerySlider.hasClass('slick-initialized') === false) {
        $gallerySlider.slick(gallerySliderSettings);
      }
    });
  },
};

export default sliders;



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js